import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpStatusCode
} from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Router, UrlTree } from '@angular/router';
import { CallerService } from '../services/caller.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private callerService: CallerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Ignore if it's from login or sign up
    if ((request.url.endsWith('/login') || request.url.endsWith('/signup')) && request.method === "POST") {
      return next.handle(request);
    }

    // Admin requests carry their own Authorization header (the admin JWT) set by AdminService.
    // Attaching the corp-member Bearer token here as well would clobber it, since HttpHeaders
    // treats header names case-insensitively.
    if (request.url.includes('/admin/')) {
      return next.handle(request);
    }

    // console.log('req', request);

    if (request instanceof HttpRequest) {
      const _token = sessionStorage.getItem(CallerService.SESSION_STORAGE_DATA_KEY)
      if (_token) {
        const requestCopy = request.clone({
          headers: request.headers.set('authorization', `Bearer ${_token}`),
          withCredentials: true
        })

        return next.handle(requestCopy);
      }
      
    }
    
    return next.handle(request);
  }
}
